import React from "react"
import { Button } from "react-bootstrap"

import { getDate, getFormattedMessage } from "../../../components/shared_components_registration"
import { adjustDateValue, parseDate } from "../../utils"
import { CertificateIcon } from "../FavouritesSelector"

export default function FavouritesList({
  favourites = [],
  type,
  onSelect,
  onShareClick,
  onExportClick,
  getText,
  intl,
}) {
  if (favourites.length === 0) {
    return (
      <p style={{ marginTop: "25px" }}>
        {getText(
          "favourites.no.favourites.message",
          "No favourites yet! Create favourites using the star icon found on graphing pages",
        )}
        &nbsp; (
        <span className={"fa fa-star"} aria-hidden={"true"} />)
      </p>
    )
  }

  return (
    <div style={{ maxHeight: "400px", overflowY: "scroll" }}>
      <table className={"table table-compact table-striped table-hover"}>
        <tbody>
          {favourites.map((f, i) => {
            const delDate = getDate(adjustDateValue(parseDate(f.date_updated), "day", 30, true), null, true)
            const graphConfigs = f.graphConfigs || []
            return (
              <tr key={i} onClick={(_) => onSelect(type, f)}>
                <td style={{ display: "flex" }}>
                  <div className={"col-1"}>
                    <Button
                      title={getText("general.share", "Share")}
                      variant={"outline-primary"}
                      className={"btn-sm"}
                      onClick={(ev) => {
                        ev.preventDefault()
                        ev.stopPropagation()
                        onShareClick(f)
                      }}
                    >
                      <span className={"fa fa-paper-plane"} />
                    </Button>
                  </div>
                  <div className={"col-1"}>
                    {type === "graph" && (
                      <Button
                        title={getText("general.export", "Export")}
                        variant={"outline-primary"}
                        className={"btn-sm"}
                        onClick={(ev) => {
                          ev.preventDefault()
                          ev.stopPropagation()
                          onExportClick(f)
                        }}
                      >
                        <span className={"fa fa-download"} />
                      </Button>
                    )}
                  </div>
                  <div className={"col-9"} style={{ cursor: "pointer", marginLeft: "auto" }}>
                    {f.name}
                    {f.view ? ` (${f.view})` : null}
                    <div style={{ fontSize: "80%", color: "var(--lanzalake-grey)" }}>{f.description}</div>
                    <div style={{ fontSize: "80%", color: "var(--lanzalake-grey)" }}>
                      {getDate(f.date_updated)}
                    </div>
                    {graphConfigs.length > 0 && (
                      <div style={{ fontSize: "80%", color: "var(--lanzalake-grey)" }}>
                        {graphConfigs.length}
                        &nbsp;
                        {getFormattedMessage("general.graphs", "Graphs", true, intl)}
                      </div>
                    )}
                  </div>
                  <div className={"col-1 text-end"}>
                    {f.trashed && (
                      <span
                        className={"fa fa-trash"}
                        title={getText(
                          "favourites.scheduled.for.deletion.on",
                          `Scheduled for deletion on ${delDate}`,
                          { date: delDate },
                        )}
                      />
                    )}
                    <CertificateIcon gs={f} intl={intl} />
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {favourites.some((f) => f.trashed) && (
        <div className={"col-12"}>
          <span style={{ fontSize: "80%", color: "var(--lanzalake-grey)" }}>
            <span className={"fa fa-trash"} />: &nbsp;
            {getText(
              "favourites.footnote",
              "Items with this icon are marked for permanent deletion. They can still be restored until their grace period expires.",
            )}
          </span>
        </div>
      )}
    </div>
  )
}
